export const IEventsDataSourceType = Symbol('IEventsDataSource');
